import React, { Component } from 'react';
import Navbar from '../layout/Navbar';
import Banner from '../common/Banner';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

class Blank extends Component {
  componentDidMount() {
    document.title = this.props.intl.formatMessage({
      id: 'blank.title'
    });
  }

  render() {
    return (
      <div>
        <Navbar />
        <FormattedMessage id="products.products">
          {products => <Banner pageName={products} />}
        </FormattedMessage>
        <section className="section-padding">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title-header text-center">
                  <p>
                    <FormattedMessage id="products.products" />
                  </p>
                  <h2 className="section-title">
                    <FormattedMessage id="blank.underConstuction" />
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-sm-12 mb-4">
                <div className="text-center">
                  <p>
                    <FormattedMessage id="blank.paragraph" />
                  </p>
                  <Link to="/" className="btn btn-common mt-2">
                    <FormattedMessage id="nav.home" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default injectIntl(Blank);
